/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/design-system/ensure-design-token-usage */
import React from 'react';
export const AtlassianIntelligenceIcon: React.VFC = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.5 14.5L17.5 17.5" stroke="#626F86" strokeWidth="1.5" strokeLinecap="square" />
        <path d="M9.5 14.5L6.5 17.5" stroke="#626F86" strokeWidth="1.5" strokeLinecap="square" />
        <path d="M9.5 9.5L6.5 6.5" stroke="#626F86" strokeWidth="1.5" strokeLinecap="square" />
        <path d="M14.5 9.5L17.5 6.5" stroke="#626F86" strokeWidth="1.5" strokeLinecap="square" />
        <path d="M12 16V19" stroke="#626F86" strokeWidth="1.5" />
        <path d="M8 12L5 12" stroke="#626F86" strokeWidth="1.5" />
        <path d="M12 8L12 4.99997" stroke="#626F86" strokeWidth="1.5" />
        <path d="M16 12L19 12" stroke="#626F86" strokeWidth="1.5" />
    </svg>
);
